module.exports = __webpack_public_path__ + "img/Gstore@2x.961cf055.png";